import React, { ReactNode } from 'react';

import '../../base.css';

type Props = {
  children?: ReactNode;
};

const PageSectionFilledTitle = ({ children }: Props) => {
  return <div styleName="page-section-filled-title">{children}</div>;
};

export default PageSectionFilledTitle;
